import Diag = require("VSS/Diag");
import * as VssContext from "VSS/Context";
import * as CoreRestClient from "TFS/Core/RestClient";
import Contracts = require("TFS/DistributedTask/Contracts");
import { ActionCreatorBase } from "DistributedTaskControls/Common/Actions/Base";
import { ActionsHubManager } from "DistributedTaskControls/Common/Actions/ActionsHubManager";
import Resources = require("DistributedTaskControls/Resources/TFS.Resources.DistributedTaskControls");
import { SharedProjectsPanelActions } from "DistributedTaskControls/SharedControls/SharedProjectsPanel/SharedProjectsPanelActions";
import { SharedProjectsPanelData } from "DistributedTaskControls/SharedControls/SharedProjectsPanel/SharedProjectsPanelModel";
import { ProjectReference } from "TFS/ServiceEndpoint/Contracts";

export class SharedProjectsPanelActionCreator extends ActionCreatorBase {

    public initialize(): void {
        this._sharePanelActions = ActionsHubManager.GetActionsHub<SharedProjectsPanelActions>(SharedProjectsPanelActions);
    }

    public getSharedProjectsData(id: any, getSharedProjects: (id: any) => IPromise<Contracts.ProjectReference[]>): void {
        CoreRestClient.getClient().getProjects("WellFormed", 1000, null).then((projects) => {
            getSharedProjects(id).then((sharedProjects) => {
                if (sharedProjects) {
                    let allProjects: Contracts.ProjectReference[] = [];
                    let currentProjectId = VssContext.getDefaultWebContext().project.id;

                    projects.forEach(project => {
                        if (project.id !== currentProjectId) {
                            let projectreference: Contracts.ProjectReference = {
                                id: project.id,
                                name: project.name
                            };

                            allProjects.push(projectreference);
                        }
                    });

                    let data: SharedProjectsPanelData = {
                        allProjects: allProjects,
                        sharedProjects: sharedProjects
                    };

                    this._sharePanelActions.sharedProjectsData.invoke(data);
                }
                else {
                    this._sharePanelActions.updateError.invoke(Resources.SharingItemDoesnotExists);
                }
            }, (reason) => {
                Diag.logError(reason);
                this._sharePanelActions.updateError.invoke(reason.message || reason);
            });
        }, (reason) => {
            Diag.logError(reason);
            this._sharePanelActions.updateError.invoke(reason.message || reason);
        });
    }

    public shareWithProjects(id: number, projects: Contracts.ProjectReference[], shareWithProjects: (id: any, projectReferences: ProjectReference[]) => IPromise<void>) {
        shareWithProjects(id, projects).then(() => {
            projects.forEach(projectReference => {
                this._sharePanelActions.addedSharedProject.invoke(projectReference);
            });
        }, (reason) => {
            Diag.logError(reason);
            this._sharePanelActions.updateError.invoke(reason.message || reason);
        });
    }

    public unshareWithProjects(id: number, projects: Contracts.ProjectReference[], unshareWithProjects: (id: any, projectReferences: ProjectReference[]) => IPromise<void>) {
        unshareWithProjects(id, projects).then(() => {
            projects.forEach(projectReference => {
                this._sharePanelActions.removedSharedProject.invoke(projectReference);
            });
        }, (reason) => {
            Diag.logError(reason);
            this._sharePanelActions.updateError.invoke(reason.message || reason);
        });
    }

    public updateSharedProjects(projects: Contracts.ProjectReference[]) {
        this._sharePanelActions.updateSharedProjects.invoke(projects);
    }

    public updateError(errorMessage: string) {
        this._sharePanelActions.updateError.invoke(errorMessage);
    }

    public handlePanelClose(): void {
        this._sharePanelActions.handlePanelClose.invoke({});
    }

    public static getKey(): string {
        return this._sharePanelActionCreatorKey;
    }

    protected getActions(): SharedProjectsPanelActions {
        return this._sharePanelActions;
    }

    private _sharePanelActions: SharedProjectsPanelActions;
    private static _sharePanelActionCreatorKey: string = "SharePanelActionCreatorKey";
}